import { Component, OnInit } from '@angular/core';
import { BancoldexService } from '../../comun/services/bancoldex.service';

@Component({
  selector: 'app-inicio-registro',
  templateUrl: './inicio-registro.component.html',
  styleUrls: ['./inicio-registro.component.scss'],
  standalone: false,
})
export class InicioRegistroComponent implements OnInit {
  descripcionPersonaNatural = '';
  descripcionPersonaJuridica = '';

  constructor(private _bancoldexService: BancoldexService) {}

  ngOnInit(): void {
    this.cargarDescripciones();
  }

  private cargarDescripciones(): void {
    const jsonPN = {
      idParametro: 'PAR-158',
      nombre: null,
      isParFuncional: true,
      pagina: 1,
    };
    this._bancoldexService.getFilterParametro(jsonPN).subscribe(
      (response) => {
        const respuesta = response['data'];
        this.descripcionPersonaNatural = String(respuesta[0].valorParametro);
      },
      (error) => {
      }
    );

    const jsonPJ = {
      idParametro: 'PAR-159',
      nombre: null,
      isParFuncional: true,
      pagina: 1,
    };
    this._bancoldexService.getFilterParametro(jsonPJ).subscribe(
      (response) => {
        const respuesta = response['data'];
        this.descripcionPersonaJuridica = String(respuesta[0].valorParametro);
      },
      (error) => {
      }
    );
  }
}
